import { render, staticRenderFns } from "./businessPricechangeRecord.vue?vue&type=template&id=a7d38c80"
import script from "./businessPricechangeRecord.vue?vue&type=script&lang=js"
export * from "./businessPricechangeRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports